/**
 * @generated SignedSource<<00c272807da160c5a86d37fa35cec730>>
 * @relayHash 719c804a5d46e940cb1520f44d19b299
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1af56c4f2d8d1e8af36fa3a5df76f5cb2e7b9680436d0662c7d242595c9830d2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HierarchyToggleMutation$variables = {
  isHierarchyEnabled: boolean;
  viewId: string;
};
export type HierarchyToggleMutation$data = {
  readonly jira: {
    readonly updateIssueSearchHierarchyPreference: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type HierarchyToggleMutation = {
  response: HierarchyToggleMutation$data;
  variables: HierarchyToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHierarchyEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isHierarchyEnabled",
            "variableName": "isHierarchyEnabled"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
        "kind": "LinkedField",
        "name": "updateIssueSearchHierarchyPreference",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HierarchyToggleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HierarchyToggleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "1af56c4f2d8d1e8af36fa3a5df76f5cb2e7b9680436d0662c7d242595c9830d2",
    "metadata": {},
    "name": "HierarchyToggleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0f2e51063d73542d963ddf74dce88747";

export default node;
